export default () => ({
  allCampaigns: [],
})
